import React from 'react';
import RedeemCoupon from './RedeemCoupon';

export default class CouponPage extends React.Component {
  render () {
    return (
      <div className="c-coupon-page">
        <RedeemCoupon/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CouponPage/CouponPage.js